export const caps = (title) => {
  return title.charAt(0).toUpperCase() + title.slice(1);
};
